<div class="container" >
    <ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
      [spinner]="spinkit.skThreeBounce">
    </ng-http-loader>
    <div class="row row-class main_header">
      <div class="col-6">
        <span class="titles">Edit Profile </span>
      </div>
      <div *ngIf="backtolocation != '1'"  class="col-6 back" (click)="logout()">
        <span class="icon icofont-logout"></span>
        Logout
      </div>
      <div class="col-6 back" *ngIf="backtolocation == '1'" (click)="backtodetails()">
        <span class="icon icofont-arrow-left"></span>
        Back
      </div>
    </div> 
    <div class="row " *ngIf="editDetails">
      <div class="upload py-4" *ngIf = "!shareID">
        <tc-form-group class="avatar-box d-flex">     
          <div class="col-3">
            <tc-avatar *ngIf = "!currentAvatar " [src]="defalutimage" [size]="80"></tc-avatar> 
            <!-- <tc-avatar *ngIf = "currentAvatar " [size]=80 [src]="currentAvatar" style="object-fit: cover;object-position: bottom;"></tc-avatar> -->
         
            <label  for="fileInput">
              <tc-avatar *ngIf = "currentAvatar "tooltip="choose File" #myTooltip="tooltip" [src]="currentAvatar" [size]="100" class="image"
              ></tc-avatar> 
            </label>
            <br/>
            <input id="fileInput" type='file' (change)="onImageChange($event)">
          </div>
          <!-- <div class="col-9" align ="center">   
            <a accept="image/*"  tooltip={{message}} #fileInput  (change)="onImageChange($event)"></a>
            <button  class="btn-default"  (click)="uploadImage()">Upload</button>
          </div> -->
            </tc-form-group>
            <label  for="fileInput">
              <p style="font-weight:500; text-align: center;color: #479943 !important;font-size: 18px; cursor: pointer;" >Change photo</p>
            </label>
            <br/>
        <div class="row" style="justify-content: center;">
          <span class="filemessage">{{ messageFilesize}}</span>
        </div>
      </div>
      <div class="row options" *ngIf = "!shareID">
        <div class="col-12 col-sm-4">
          <a (click)="onclickmydetail()">My details
            <span style="float: right;">
              <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
            </span>
          </a>
          <hr style="width: 100%; color: black; margin-top: 10px;">
        </div>
        &nbsp;
        <div class="col-12 col-sm-4">
          <a (click)="onclickfood()"> My food Preferences
            <span style="float: right;">
              <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
            </span>
          </a>
          <hr style="width: 100%; color: black; margin-top: 10px;">
        </div>
        &nbsp;
        
        <div class="col-12 col-sm-4" *ngIf ="taste_code " >
          <a (click)="onclickMyfriends()">My friends
            <span style="float: right;">
              <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
            </span>
          </a>
          <hr style="width: 100%; color: black; margin-top: 10px;">
        </div>
        <div class="col-12 col-sm-4" *ngIf ="taste_code ">
          <a (click)="onclickShare()">Share with your friends
            <span style="float: right;">
              <tc-icon [iconClass]="'icofont-rounded-right'" [tcFontSize]="25" [padding]="0"></tc-icon>
            </span>
          </a>
        </div>   
      </div>
    </div> 
    <div *ngIf="clickmydetail && (!clickfood && !myfriends && !sharefriends)">
      <div class="row row-class">
        <div class="col-6 py-4">
          <span style="color: black; font-size: 16px; font-weight: 400;">My details </span>
        </div>
      </div>
      <div class="row justify-content-center py-2">
        <div class="col col-12 col-xl-10">
          <form novalidate class="mb-4">
            <tc-form-group>
              <label for="">First name</label>
              <tc-input [placeholder]="'First name*'" [(ngModel)]="up_fname" [ngModelOptions]="{standalone: true}">
              </tc-input>
            </tc-form-group>
            <tc-form-group>
              <label for="">Last name</label>
              <tc-input [placeholder]="'Last name'" [(ngModel)]="up_lname" [ngModelOptions]="{standalone: true}">
              </tc-input>
            </tc-form-group>
            <tc-form-group *ngIf = "taste_code">
              <label for="">Unique taste id</label>
              <tc-input [placeholder]="'Unique taste id'" [readonly]="true" [(ngModel)]="taste_code"
                [ngModelOptions]="{standalone: true}"></tc-input>
            </tc-form-group>
            <tc-form-group>
              <label for="">Gender</label>
              <tc-select [placeholder]="'Gender'" [selected]="up_gender" [(ngModel)]="up_gender" [options]="data"
                [ngModelOptions]="{standalone: true}"></tc-select>
            </tc-form-group>
            <div class="row">
              <div class="col-6 col-sm-6 col-xs-6">
                <tc-form-group>
                  <label for="feet">Height</label>
                  <tc-select [placeholder]="'Feet'" [selected]="feet" [(ngModel)]="feet" [options]="datafeet"
                    [ngModelOptions]="{standalone: true}"></tc-select>
                </tc-form-group>
              </div>
  
              <div class="col-6 col-sm-6 col-xs-6">
                <tc-form-group>
                  <label for="Inch">Inch</label>
                  <tc-select [placeholder]="'Inch'" [selected]="up_inch" [(ngModel)]="up_inch" [options]="datainch"
                    [ngModelOptions]="{standalone: true}"></tc-select>
                </tc-form-group>
              </div>
            </div>
            <tc-form-group *ngIf = "(is_google || is_facebook ) && (is_facebook == 'Yes'|| is_google == 'Yes')" >
              <div class="row">
                <div class="col-6 col-sm-6 col-xs-6">
                  <label for="number">Social Account linked</label> &nbsp;
                </div>
                <div class="col-6 col-sm-6 col-xs-6" *ngIf = "is_facebook == 'Yes'">
                  <img src="./assets/img/facebookicon.png" alt="" width ="15"> &nbsp;
                </div>
                <div class="col-6 col-sm-6 col-xs-6" *ngIf = "is_google == 'Yes'">
                <img src="./assets/img/googleicon.png" alt="" width="25">
              </div>
              </div>
            </tc-form-group>
            <div class="row email_tx">
              <div class="col-4">
                <tc-form-group>
                  <h6 >Email</h6>
                </tc-form-group>
              </div>
              <div class="col-8" >
                <tc-form-group>
                  <h6 >{{email}}</h6>
                </tc-form-group>
              </div>
            </div>
            <tc-form-group>
              <label for="number">Phone number</label>
              <tc-input [placeholder]="'Phone number'" [(ngModel)]="up_phone" [ngModelOptions]="{standalone: true}">
              </tc-input>
            </tc-form-group>
            <tc-form-group>
              <label for="address">Address</label>
              <tc-textarea [placeholder]="'Address'" [(ngModel)]="up_address" [ngModelOptions]="{standalone: true}">
              </tc-textarea>
            </tc-form-group>
            <div align="center">
              <button style="background: #47941b !important;" tc-button [view]="'accent'" (click)="updateProfile(up_fname
            ,up_lname,up_phone,up_gender,up_address,feet,up_inch)">
                Update Profile
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  
    <div *ngIf="clickfood && (!clickmydetail && !myfriends && !sharefriends) && load">
      <div class="row row-class">
        <div class="col-12 ">
          <span style="color: black; font-size: 16px; font-weight: 400;">My food preferences</span>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-xl-10 py-12">
          <form novalidate #heroForm="ngForm" class="new-patient-form ">
            <tc-form-group>
              <label for="">My food Allergies/Intolerance</label>
              <ng-select [(ngModel)]="allergensarry" name="allergensarry" [items]="allAllergens"
                bindLabel="allergens_name" bindValue="allergens_id" [multiple]="true" [virtualScroll]="true"
                placeholder="Select food Allergies/Intolerance" required>
              </ng-select>
            </tc-form-group>
            <tc-form-group>
              <label for="">My Deitary preferences</label>
              <ng-select [(ngModel)]="dietaryarry" name="dietaryarry" [items]="alldietary"
                bindLabel="diet_preference_name" bindValue="diet_preference_id" [multiple]="true" [virtualScroll]="true"
                placeholder="Select Deitary preferences" required>
              </ng-select>
            </tc-form-group>
            <tc-form-group>
              <label for="">My favorite ingredients</label>
              <ng-select [(ngModel)]="ingredientbind" name="ingredientbind" [items]="user_ingredients"
                bindLabel="sub_ingredient_name" bindValue="sub_ingredient_id" [multiple]="true" [virtualScroll]="true"
                placeholder="Select favorite ingredients" required>
              </ng-select>
            </tc-form-group>
            <tc-form-group>
              <label for="">My Spice tolerance</label>
              <tc-select [placeholder]="'Select Spice tolerance'" [selected]="user_preference_spice"
                [(ngModel)]="user_preference_spice" [options]="datas" [ngModelOptions]="{standalone: true}"></tc-select>
            </tc-form-group>
            <tc-form-group>
              <label for="">Dislikes</label>
              <ng-select [(ngModel)]="userDislikesbind" name="userDislikesbind" [items]="user_ingredients"
                bindLabel="sub_ingredient_name" bindValue="sub_ingredient_id" [multiple]="true" [virtualScroll]="true"
                placeholder="Dislikes" required>
              </ng-select>
            </tc-form-group>
            <div align="center">
              <button style="background: #47941b !important; margin-top: 10px;" tc-button [view]="'accent'"
                (click)="UpdatefoodPreferences(allergensarry,dietaryarry,ingredientbind,user_preference_spice,userDislikesbind)">
                Update Profile
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div *ngIf = "myfriends && (!clickmydetail && !clickfood && !sharefriends)" >
        <div class="row row-class">
          <div class="col-6">
              <span style="color: black; font-size: 16px; font-weight: 400;">My Friends</span>
            </div>
          </div>
              <div  *ngIf = "listoffriends.length == 0">
                <div class="share_link" align="center"> 
                  <h4>Share this link with your friends to compare</h4>
                  <p  class="text-center">{{Baselinkshare}} </p>
                </div>
                <div class="row share_link" align="center">
                  <div class="col-4">
                   <img src="./assets/img/facebook.png" (click)="onclickFb()" alt="">
                  </div>
                  <div class="col-4">
                    <img src="./assets/img/whatsup.png" (click)="onclickwhatapp()"  alt="">
                  </div>
                  <div class="col-4">
                 <img src="./assets/img/Twitter.png" (click)="onclickTwitter()"  alt="">
                  </div>
                </div>
            </div>
            <div class="row" *ngIf = "listoffriends.length != 0"> 
              <div class="col-12">
                <div class="card" *ngFor ="let friends of listoffriends">
                  <div class="image pull-left">
                      <span   class="image" *ngIf = "!friends.image">
                          <img src="./assets/img/PngItem_1503945.png"  alt="" >
                        </span>
                        <span class="avatar" *ngIf ="friends.image">        
                          <tc-avatar  [src]="friends.image" [size]="76" ></tc-avatar>
                        </span> 
                  </div>
                  <div class="content">
                      <h6>{{friends.tc_name}}</h6>
                      <span> {{friends.matchScore}}% </span>
                     
                  </div>
                  <div class="clearfix" >           
                      <tc-dropdown class="item" [close]="closeDropdown">
                          <tc-dropdown-button>
                            <div class="d-flex align-items-center">
                              <mat-icon>more_vert</mat-icon> 
                            </div>
                          </tc-dropdown-button>
                          <tc-dropdown-content class="dropdown_wrap"  [align]="'right'" [animation]="'fadeInUp'" [offset]="[10, 0]" [width]="180">
                            <ul class="list">
                              <li>
                                <a class="align-items-center dining">
                                  <span class="icon icofont-dining-table" [tcFontSize]="28" ></span>
                                  Plan a meal with friend
                                </a>
                                <a class="align-items-center delete" (click) ="ondeletefriend(friends.friend_id)">
                                  <span class="icon icofont-ui-delete" [tcFontSize]="25" ></span>
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </tc-dropdown-content>
                        </tc-dropdown>  
                      </div>
                </div>
              </div>
        </div>         
    </div>
   

    <div *ngIf = "(sharefriends || shareID ) && (!clickmydetail && !clickfood && !myfriends)">
        <div class="row row-class">
            <div class="col-12 py-4">
              <span style="color: black; font-size: 16px; font-weight: 400;">Share with your friends </span>
            </div>
          </div>
          <div class="share_link" align="center">
            <h4 >Share this link with your friends to compare</h4>
            <p  class="text-center">{{Baselinkshare}} </p>
          </div>
        <div class="row share_link" align="center">
              <div class="col-4">
                <a href="">
                  <img src="./assets/img/facebook.png" (click)="onclickFb()" alt="">
                </a>
              </div>
              <div class="col-4">
                <a href="">
                  <img src="./assets/img/whatsup.png" (click)="onclickwhatapp()" alt="">
                </a>
              </div>
              <div class="col-4">
                <a href="">
                  <img src="./assets/img/Twitter.png" (click)="onclickTwitter()" alt="">
                </a>
              </div>
          </div>
        </div>
    <div class="row" style="justify-content: center;  margin-top: 60px; ">
        <a [routerLink]="['../', 'userprofile']">
          <span class="moreTitle">
            Back to Profile
          </span> </a>
    </div>
    <br>
    <br>
    <br>
    <div class="bottom_nav">
    <div class="row stickyButton" style="padding-top: 5px;padding-bottom: 5px;">
        <div *ngIf="UserCondition" class="footernav h-100 py-2">
          <ul class="nav nav-pills row" style=" padding-left: 0px;padding-right: 0px;width: 100%;">
            <li class="nav-item col-xs-6">
              <a [routerLink]="['../', 'resto']" class="nav-link">
                <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="28"></tc-icon>
                <span class="nav__text">Restaurant</span>
              </a>
            </li>
            <li class="nav-item col-xs-6 ">
              <a [routerLink]="['../',  'userprofile']"  class="active nav-link">
                <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="26"></tc-icon>
                <span class="nav__text">Profile</span>
              </a>
            </li>
          </ul>
        </div>
      </div>  
    </div>
  </div>